import { avatarHue, initials } from "../lib/format";
import { AVATAR_PASTEL_INK, AVATAR_PASTELS } from "../lib/floorPalette";

/** The design's pastel (`HW_AV_BG`) for a person — picked from their user id,
 *  not their name, so a rename does not change how somebody looks. */
export function avatarPastel(id: string): string {
  return AVATAR_PASTELS[avatarHue(id) % AVATAR_PASTELS.length];
}

/**
 * A person's photo, or — when there is none — their initials on one of the
 * design's pastel discs (weco2/homework-data.jsx `HwAvatar`). Deterministic
 * from the user id, so nothing is stored or fetched and a person looks the same
 * on the floor, in lists and on their card.
 */
export function Avatar({
  name,
  id,
  url,
  size = 32,
  className = "",
}: {
  name: string;
  id: string;
  url?: string;
  size?: number;
  className?: string;
}) {
  if (url) {
    return (
      <img
        src={url}
        alt=""
        width={size}
        height={size}
        className={`rounded-full object-cover ${className}`}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <span
      aria-hidden
      className={`inline-flex shrink-0 items-center justify-center rounded-full font-semibold ${className}`}
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.36),
        background: avatarPastel(id),
        color: AVATAR_PASTEL_INK,
      }}
      title={name}
    >
      {initials(name)}
    </span>
  );
}
